(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-registry/assets/javascripts/use-is-scrolling.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-registry/assets/javascripts/use-is-scrolling.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const _ref = _,
  throttle = _ref.throttle;

const useIsScrolling = function () {
  let delayInMS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isScrolling = _useState2[0],
    setIsScrolling = _useState2[1];
  useEffect(() => {
    let scrollingTimeout;
    let isCurrentlyScrolling;
    const handleScroll = throttle(() => {
      if (!isCurrentlyScrolling) {
        setIsScrolling(true);
        isCurrentlyScrolling = true;
      }
      clearTimeout(scrollingTimeout);
      scrollingTimeout = setTimeout(() => {
        setIsScrolling(false);
      }, delayInMS);
    }, 200);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollingTimeout);
    };
  }, [delayInMS, isScrolling]);
  return isScrolling;
};
setGlobal('svs.components.tipsen.betslipRegistry.useIsScrolling', useIsScrolling);

 })(window);